import { BLOCK_TYPES } from "../../common/index";
import { MCQ_DEFAULT_VALUE } from "../MCQ";
import { v4 as uuid } from "uuid";

const { V2_RAPID_QA_BLOCK } = BLOCK_TYPES;

const getV2RapidQADefaultValue = () => ({
    type: V2_RAPID_QA_BLOCK,
    data: {
        [V2_RAPID_QA_BLOCK]: {
            title: "",
            sub_title: "",

            banner: "",
        },

        other: {
            duration: 0,
            audio: "",
        },
    },
    children: [
        {
            ...MCQ_DEFAULT_VALUE,
            order: 1,
            tmpId: uuid(),
        },
    ],
});

export default getV2RapidQADefaultValue;
